// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2XTgv","base":"styles_base__2AOV9"};